import React from "react";
import styled from "styled-components";
import PersonnelProfileNewTabLink from "../../PersonnelProfileNewTabLink";
import { AccordionHeader, StyledIcon } from "./bulkReviewResolveStyles";
import { formatBulkResolvePersonName } from "./bulkReviewResolveUtils";

const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 0;
`;

const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const ChoiceLabel = styled.span`
    font-family: Helvetica;
    font-size: 12px;
    color: #041e42;
    white-space: nowrap;
`;

const RemoveButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
`;

export type BulkReviewResolveAccordionHeaderProps = {
    personnelId: number;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    affiliationAbbrev?: string;
    complete: boolean;
    choiceLabel: string | null;
    expanded: boolean;
    onToggle: () => void;
    onRemove: (e: React.MouseEvent) => void;
};

const BulkReviewResolveAccordionHeader: React.FC<BulkReviewResolveAccordionHeaderProps> = ({
    personnelId,
    firstName,
    middleName,
    lastName,
    affiliationAbbrev,
    complete,
    choiceLabel,
    expanded,
    onToggle,
    onRemove,
}) => (
    <AccordionHeader onClick={onToggle}>
        <HeaderLeft>
            {complete ? (
                <StyledIcon color="green" iconName="fa-check-circle" />
            ) : (
                <StyledIcon color="var(--blue-grey)" iconName="fa-circle-o" />
            )}
            <PersonnelProfileNewTabLink personnelId={personnelId}>
                {formatBulkResolvePersonName({
                    firstName,
                    middleName,
                    lastName,
                    affiliationAbbrev,
                })}
            </PersonnelProfileNewTabLink>
        </HeaderLeft>
        <HeaderActions>
            {choiceLabel ? <ChoiceLabel>{choiceLabel}</ChoiceLabel> : null}
            <RemoveButton title="Remove from list" onClick={onRemove}>
                <StyledIcon color="var(--blue)" iconName="fa-times" />
            </RemoveButton>
            <StyledIcon color="#041e42" iconName={expanded ? "fa-chevron-up" : "fa-chevron-down"} />
        </HeaderActions>
    </AccordionHeader>
);

export default BulkReviewResolveAccordionHeader;
